module.exports = __webpack_public_path__ + "img/about-even-fondo.e36857e2.jpg";